// Central CTA config. The whole platform is enquiry-led today.
// To switch a payable "Book Now" flow on later, set mode to "book" and point
// bookHref at the checkout route — NOTHING ELSE on any page needs to change.
// Every CtaButton keeps its exact position, size and prominence either way.
export const CTA_CONFIG = {
  mode: "enquire", // "enquire" | "book"
  enquireLabel: "Enquire",
  bookLabel: "Book Now",
  bookHref: "/checkout",
};
